/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit IconPicker/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import IconDialog from './IconDialog/index'
import React from 'react'
import TaskBoardIcon from 'DesignSystem/TaskBoardIcon/index'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function IconPicker({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main/Settings/IconPicker"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let selectedBoardIconIdValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'board_icon_id',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginBottom={dtSpaceXxs}
 weight="medium"
 size="normal"
 text="Board image"
/>
<div
  data-testid="IconPicker.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="IconPicker.Vertical"
  data-view-path={viewPath}
 style={{'--mb-1-1E6Pzi': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical}`}
>
<TaskBoardIcon
  viewPath={`${viewPath}/TaskBoardIcon`}
 data="selected.board_icon_id"
 iconId={selectedBoardIconIdValueData}
/>
</div>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 size="normal"
 marginTop={dtSpaceS}
 marginLeft={dtSpaceXs}
 type="secondary"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'IconDialog/Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'IconDialog/Content'))}
 text="Change image"
/>
</div>
<IconDialog
  viewPath={`${viewPath}/IconDialog`}
/>
{children}
</React.Fragment>)
}